import React from 'react';
import { Content, Header } from '@backstage/core-components';
import { AccessDashboard } from '../components/AccessDashboard/AccessDashboard';
import { useMyTeamRoles } from '../components/AccessDashboard/useMyTeamRoles';

export default function DashboardPage() {
  const rolesQuery = useMyTeamRoles();
  const teamName = rolesQuery.data?.teamName;
  const subtitle = teamName
    ? `Your roles for ${teamName} — review what you hold and request what you need.`
    : 'Review what you hold and request what you need.';

  return (
    <>
      <Header
        pageTitleOverride="Access Dashboard"
        title="Access Dashboard"
        subtitle={subtitle}
      />
      <Content>
        <AccessDashboard />
      </Content>
    </>
  );
}
